import SettingsIcon from '@mui/icons-material/Settings';
import { SettingsEdit } from './SettingsEdit';
import { SettingsList } from './settingsList';

const settings = {
  list: SettingsList,
  edit: SettingsEdit,
  icon: SettingsIcon,
};

export default settings;
